/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ScanToPayLoyaltyProfileQueryVariables = Exact<{ [key: string]: never }>;

export type ScanToPayLoyaltyProfileQuery = {
  readonly loyaltyProfile: {
    readonly customerId: string;
    readonly points: { readonly available: number } | null;
    readonly pointsRewards: ReadonlyArray<{
      readonly __typename: 'PointsReward';
      readonly id: string;
      readonly points: number;
      readonly redeemable: boolean;
      readonly assetUrl: string | null;
      readonly name: string;
    }> | null;
  } | null;
};

export const ScanToPayLoyaltyProfileDocument = gql`
  query ScanToPayLoyaltyProfile {
    loyaltyProfile {
      customerId
      points {
        available
      }
      pointsRewards {
        id
        __typename
        points
        name: displayName
        redeemable
        assetUrl
      }
    }
  }
`;

export function useScanToPayLoyaltyProfileQuery(
  options?: Omit<Urql.UseQueryArgs<ScanToPayLoyaltyProfileQueryVariables>, 'query'>,
) {
  return Urql.useQuery<ScanToPayLoyaltyProfileQuery, ScanToPayLoyaltyProfileQueryVariables>({
    query: ScanToPayLoyaltyProfileDocument,
    ...options,
  });
}
